export class LocalizeCertificateConstantes {
  public static SESSION_CERTIFICATE_ANONYMOUS = 'sessionCertificteAnonymous';
  public static SESSION_CERTIFICATE_ANONYMOUS_NOME = 'sessionCertificteAnonymousNome';
  public static SESSION_CERTIFICATE_ANONYMOUS_CPF = 'sessionCertificteAnonymousCpf';
  public static SESSION_CERTIFICATE_ANONYMOUS_CNPJ = 'sessionCertificteAnonymousCnpj';
}